import SEO from "@/components/common/SEO";
import LegalLayout from "./LegalLayout";

import {
  organizationSchema,
  breadcrumbSchema,
} from "../../components/common/schema";

const schemas = [
  organizationSchema(),

  breadcrumbSchema([
    {
      name: "Home",
      path: "/",
    },
    {
      name: "Disclaimer",
      path: "/disclaimer",
    },
  ]),
];

export default function Disclaimer() {
  return (
    <>
      <SEO
        title="Disclaimer"
        description="Read the legal disclaimer regarding Money Mart's loan advisory services, information accuracy and lender responsibilities."
        canonical="/disclaimer"
        structuredData={schemas}
      />
      <LegalLayout
        title="Disclaimer"
        description="Please read this Disclaimer carefully before using the Money Mart website or relying on any information provided through our services."
        lastUpdated="24 July 2026"
      >
        <h2>1. General Information</h2>

        <p>
          The information provided on this website is intended solely for
          general informational purposes. While Money Mart makes every
          reasonable effort to ensure that the information published is
          accurate, complete, and up-to-date, we make no representations or
          warranties of any kind, express or implied, regarding its accuracy,
          reliability, suitability, or completeness.
        </p>

        <br />

        <h2>2. No Lending Activity</h2>

        <p>
          Money Mart is a loan advisory and Bank Channel Partner (DSA) that
          facilitates loan applications with RBI-regulated Banks and NBFCs.
        </p>

        <p>
          We do not directly provide loans, issue credit facilities, accept
          deposits, or make lending decisions.
        </p>

        <p>
          All financial products displayed on this website are offered solely by
          their respective Banks and NBFCs.
        </p>

        <br />

        <h2>3. No Guarantee of Loan Approval</h2>

        <p>
          Using this website or submitting an enquiry does not guarantee loan
          approval, loan sanction, disbursement, interest rate, repayment
          tenure, or any specific loan amount.
        </p>

        <p>
          Every loan application is independently evaluated by the respective
          lending institution based on its internal credit policies, eligibility
          criteria, risk assessment, documentation, verification process, and
          applicable regulations.
        </p>

        <br />

        <h2>4. Interest Rates & Charges</h2>

        <p>
          Interest rates, processing fees, foreclosure charges, documentation
          requirements, repayment terms, and other applicable charges are
          decided exclusively by the respective Bank or NBFC.
        </p>

        <p>
          The figures shown on this website, including illustrative examples,
          calculators, and eligibility estimates, are indicative only and should
          not be treated as final quotations or offers.
        </p>

        <br />

        <h2>5. Financial Calculators</h2>

        <p>
          EMI calculators, eligibility calculators, affordability tools, and
          other financial calculators available on this website are provided for
          estimation purposes only.
        </p>

        <p>
          Actual loan eligibility, EMI, repayment schedule, and sanctioned
          amount may vary depending on lender policies and individual applicant
          circumstances.
        </p>

        <br />

        <h2>6. No Professional Financial Advice</h2>

        <p>
          Information available on this website should not be interpreted as
          financial, investment, legal, accounting, or tax advice.
        </p>

        <p>
          Users are encouraged to consult qualified professionals before making
          financial decisions based on information obtained through this
          website.
        </p>

        <br />

        <h2>7. Customer Responsibility</h2>

        <p>
          Users are solely responsible for ensuring that all information and
          documents submitted during the loan application process are complete,
          genuine, and accurate.
        </p>

        <p>
          Submission of false or misleading information may result in rejection
          of the application by the lending institution and may attract legal
          consequences under applicable laws.
        </p>

        <br />

        <h2>8. Third-Party Information</h2>

        <p>
          Our website may contain information relating to Banks, NBFCs,
          financial institutions, government agencies, and third-party service
          providers.
        </p>

        <p>
          Money Mart does not guarantee the accuracy, completeness,
          availability, or reliability of information provided by third parties
          and shall not be responsible for any inaccuracies or changes made by
          them.
        </p>

        <br />

        <h2>9. External Links</h2>

        <p>
          This website may include links to external websites for your
          convenience.
        </p>

        <p>
          Money Mart has no control over the content, privacy practices,
          availability, or security of third-party websites and accepts no
          responsibility for their content or services.
        </p>

        <br />

        <h2>10. Website Availability</h2>

        <p>
          We strive to keep our website operational at all times. However, we do
          not guarantee uninterrupted access, freedom from technical errors, or
          continuous availability.
        </p>

        <p>
          Website maintenance, software updates, server issues, or circumstances
          beyond our control may temporarily affect availability.
        </p>

        <br />

        <h2>11. Limitation of Liability</h2>

        <p>
          To the fullest extent permitted by applicable law, Money Mart shall
          not be liable for any direct, indirect, incidental, consequential,
          special, or punitive damages arising from:
        </p>

        <ul>
          <li>Use of this website.</li>
          <li>Reliance on information published on this website.</li>
          <li>Loan rejection by any lending institution.</li>
          <li>Delay in loan processing or disbursement.</li>
          <li>Technical interruptions or website downtime.</li>
          <li>Loss of business, income, data, or opportunities.</li>
        </ul>

        <br />

        <h2>12. Intellectual Property</h2>

        <p>
          All content, branding, graphics, logos, text, software, layouts, and
          design elements appearing on this website are the intellectual
          property of Money Mart unless otherwise stated.
        </p>

        <p>
          Unauthorized reproduction, modification, distribution, or commercial
          use of any material is prohibited without prior written permission.
        </p>

        <br />

        <h2>13. Regulatory Compliance</h2>

        <p>
          Money Mart conducts its operations in accordance with applicable laws
          and industry practices. However, lending decisions remain the sole
          responsibility of the respective RBI-regulated Banks and NBFCs.
        </p>

        <br />

        <h2>14. Changes to this Disclaimer</h2>

        <p>
          Money Mart reserves the right to modify, update, or replace this
          Disclaimer at any time without prior notice.
        </p>

        <p>
          Continued use of the website after any changes constitutes acceptance
          of the revised Disclaimer.
        </p>

        <br />

        <h2>15. Contact Us</h2>

        <p>
          If you have any questions regarding this Disclaimer, please contact
          Money Mart using the contact details provided on our website.
        </p>
      </LegalLayout>
    </>
  );
}
